import { AdditionalDetailType } from '../../enrollment/models/submit-enrollment'
import { EnrollmentField } from '../../enrollment/models/enrollment-field'


export class GetEnrollmentDataResponse {
    Data: EnrollData
}


export class EnrollData {
    EnrollmentKey: string
    ClientCode: string
    SourceCode: string
    BatchKey: string
    SubmissionTypeCode: string
    SubmissionStatus: string
    EnrollmentFields: EnrollmentField[]
    AdditionalDetails: AdditionalDetailType[]
    EnrollmentStatus: string
}

export class GetEnrollmentDataByID
{
    ConfirmationNumber: string
    AgentID: string
    DataEntryID: string
    Title: string
    Suffix: string
    AppliantFirstName: string
    ApplicantMiddleInitial:string

    ApplicantLastName: string
    MedicareNumber: string
    PlanYear: string
    ApplicationDate: string
    EffectiveDate: string
    ApplicantState: string
    SelectedPlan: string

    CUID: string
    PrimaryCarrier: string
    PrimaryAccount: string
    PrimaryGroup: string
    SecondaryCarrier: string
    SecondaryAccount: string
    SecondaryGroup: string

    RelationshipCode: string
    FamilyID: string
    PersonCode: string
    SecondaryMemberID: string
    SecondaryName: string
    SEFEffectiveDate: string
    ElectionPeriod: string

    EnrollmentCriteria: string
    EnrollmentCriteriaDescription: string
    EnrollmentType: string
    AgentEnrollmentType: string
    PhoneNumber: string
    CellPhone: string
    DateOfBirth: string

    Gender: string
    Email: string
    PermanentAddressLine1: string
    PermanentAddressLine2: string
    PermanentCity: string
    PermanentState: string
    PermanentZip: string
    PoverInd:string

    MailingAddressLine1: string
    MailingAddressLine2: string
    MailingCity: string
    MailingState: string
    MailingZipCode: string
    LongTermCareFacility: string
    LongTermCarePhone: string

    MedicarePartADate: string
    MedicarePartBDate: string
    PremiumPaymentType: string
    LanguagePreference: string
    ElectronicExplanationOfBenefits: string
    LanguagePrintFormatCode: string
    CareQualifier: string
    CareFacility: string

    OtherCoverageName: string
    OtherCoverageID: string
    OtherCoverageGroup: string
    OtherCoverageRxBIN: string
    OtherCoverageRxPCN: string
    OtherCoverageEffectiveDate: string
    OtherCoverageTerminationDate: string

    AuthorizedRepresentativeName: string
    AuthorizedRepresentativePhone: string
    AuthorizedRepresentativeRelationship: string
    AuthorizedRepresentativeAddressLine1: string
    AuthorizedRepresentativeAddressLine2: string
    AuthorizedRepresentativeCity: string
    AuthorizedRepresentativeState: string

    AuthorizedRepresentativeZipCode: string
    AccountType: string
    RoutingNumer: string
    FinancialInstitution: string
    AccountNumber: string
    AccountName: string
    ExternalId: string
    Notes: string

    DisenrollmentInd: string = ''
    DisenrollmentDate: string
    DisenrollmentNoticeDate: string
    DisenrollmentReasonCode: string = ''
    DisenrollmentType: string = ''

    EnrolleeWorkStatus: string
    SpouseWorkStatus: string


    Race: string
    Ethnicity: string

    GenderIdentity: string
    DifferentGenderIdentity: string
    SelfIdentity: string
    DifferentSelfIdentity: string

    IndividualRepName: string
    RelationshipToEnrollee: string
    NPN: string

}

